/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Feedback volume for one UTC day.
 */
export type SkillFeedbackTimelinePoint = {
  /**
   * The start of the UTC day.
   */
  bucketStart: Date;
  feedbackCount: number;
};

/** @internal */
export const SkillFeedbackTimelinePoint$inboundSchema: z.ZodMiniType<
  SkillFeedbackTimelinePoint,
  unknown
> = z.pipe(
  z.object({
    bucket_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    feedback_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start": "bucketStart",
      "feedback_count": "feedbackCount",
    });
  }),
);

export function skillFeedbackTimelinePointFromJSON(
  jsonString: string,
): SafeParseResult<SkillFeedbackTimelinePoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillFeedbackTimelinePoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillFeedbackTimelinePoint' from JSON`,
  );
}
